import { useMutation, useQuery } from "@tanstack/react-query";
import { errorFormat } from "./handleError.utils";
import { onSuccessMessage, queryClient } from "./reactQuery.utils";
import useAxiosInstance from "./axiosInstance.utils";

/**
 * :::::::MUTATIONS:::::::::::
 */

export function useCreateModuleMutation(keyData) {
  const { postApi } = useAxiosInstance();
  async function createModuleApi(data) {
    try {
      const api = `/module`;
      const apiResponse = await postApi(api, data);
      return apiResponse;
    } catch (error) {
      return errorFormat(error);
    }
  }

  const { isPending: loading, mutateAsync } = useMutation({
    mutationKey: ["createModuleApi", ...keyData],
    mutationFn: (data) => createModuleApi(data),
    onSuccess: (data) => {
      queryClient.invalidateQueries("modules");
      onSuccessMessage(data, 201);
    },
    onError: (err) => {
      return errorFormat(err);
    }
  });

  return { loading, createModule: mutateAsync };
}

export function useUpdateModuleMutation(keyData) {
  const { putApi } = useAxiosInstance();

  async function updateModuleApi({ id, ...data }) {
    try {
      const api = `/module/${id}`;
      const apiResponse = await putApi(api, data);
      return apiResponse;
    } catch (error) {
      return errorFormat(error);
    }
  }

  const { isPending: loading, mutateAsync } = useMutation({
    mutationKey: ["updateModuleApi", ...keyData],
    mutationFn: (data) => updateModuleApi(data),
    onSuccess: (data) => {
      queryClient.invalidateQueries("modules");
      onSuccessMessage(data, 200);
    },
    onError: (err) => {
      return errorFormat(err);
    }
  });

  return { loading, updateModule: mutateAsync };
}

export function useDeleteModuleMutation(keyData) {
  const { deleteApi } = useAxiosInstance();

  async function deleteModuleApi(id) {
    try {
      const api = `/module/${id}`;
      const apiResponse = await deleteApi(api);
      return apiResponse;
    } catch (error) {
      return errorFormat(error);
    }
  }

  const { isPending: loading, mutateAsync } = useMutation({
    mutationKey: ["deleteModuleApi", ...keyData],
    mutationFn: (data) => deleteModuleApi(data),
    onSuccess: (data) => {
      queryClient.invalidateQueries("modules");
      onSuccessMessage(data, 200);
    },
    onError: (err) => {
      return errorFormat(err);
    }
  });

  return { loading, deleteModule: mutateAsync };
}

export function useAssignModulePermissionMutation(keyData) {
  const { putApi } = useAxiosInstance();

  async function assignModulePermissionApi({ id, ...data }) {
    try {
      const api = `/module/assign/permission`;
      const apiResponse = await putApi(api, data);
      return apiResponse;
    } catch (error) {
      return errorFormat(error);
    }
  }

  const { isPending: loading, mutateAsync } = useMutation({
    mutationKey: ["assignModulePermissionApi", ...keyData],
    mutationFn: (data) => assignModulePermissionApi(data),
    onSuccess: (data) => {
      queryClient.invalidateQueries("modules");
      onSuccessMessage(data, 200);
    },
    onError: (err) => {
      return errorFormat(err);
    }
  });

  return { loading, assignModulePermission: mutateAsync };
}

/**
 * :::::::QUERIES:::::::::::
 */
export function useGetAllModuleQuery({ query, options = {} }) {
  const { getApi } = useAxiosInstance();

  async function getAllModuleApi(query) {
    try {
      const api = `/modules${query ?? ""}`;
      const apiResponse = await getApi(api);
      return apiResponse;
    } catch (error) {
      return errorFormat(error);
    }
  }

  const { data, isPending: loading } = useQuery({
    queryKey: [`getAllModule-${query ?? ""}`],
    queryFn: () => getAllModuleApi(query),
    ...options
  });
  const newData = data?.data?.modules ?? {};
  return { data: newData, loading };
}
